import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitle: {
		id: 'eoc-heartbeats.page-title',
		defaultMessage: 'Heartbeats',
		description: 'The title (browser document title) of the Custom fields directory page',
	},
});
